// import Sierpinski from "./Sierpinski";

import { Sierpinski } from "./Sierpinski";

export { Sierpinski, pointInTriangle } from "./Sierpinski";

export const greet = () => console.log("Hello, World!");
// Access the CanvasDrawer class from the bundled script
// const canvas = document.getElementById("myCanvas");
// if (canvas) {
//   console.log("sierpinski!");
//   const drawer = new Sierpinski(canvas as HTMLCanvasElement);

//   // Draw some dots
//   drawer.drawDot(50, 50); // Default size and color
//   drawer.drawDot(100, 100, 10, "red"); // Red dot
//   drawer.drawDot(200, 150, 8, "blue"); // Blue dot
// } else {
//   console.error("no canvas found");
// }
